import WebComponent from '../base/WebComponent';

class EvalClosed extends WebComponent {
    questionCols = [];
    handleResizeTimer = null;
    productId = null;
    relatedProducts = [];
    useClerk = false;
    areaId = null;

    async beforeMount() {
        const {slots, productId, relatedProducts, useClerk, areaId} = this.props;
        
        this.productId = productId || null;
        this.relatedProducts = relatedProducts || [];
        this.useClerk = useClerk || false;
        this.slots = slots || this.slots;
        this.areaId = areaId || null;
    }

    mounted() {
        const relatedProductElm = document.createElement('eval-related-products');
        relatedProductElm.currentProductId = this.productId;
        relatedProductElm.areaId = this.areaId;
        relatedProductElm.relatedProducts = this.relatedProducts;
        relatedProductElm.useClerk = this.useClerk;
        this.querySelector('[ref="mountRelated"]').appendChild(relatedProductElm);

        setTimeout(() => {
            this.scrollIntoView({
                block: "center",
                inline: "center",
                behavior: "smooth"
            });
        })
    }

    template() {
        return `
            <article class="fu-eval__group primary__bg secondary__text secondary__headlines secondary__content tertiary__links" grid="wrap">
                <header class="flexy direction--column justify--center" column="s-12 l-11 l+1">
                    ${this.slots.closeMessage ? this.slots.closeMessage.innerHTML : ''}
                </header>
                <main class="fu-eval__submit-main" column="s-12 l-11 l+1" ref="mountRelated"></main>
            </article>
        `;
    }
  }
  
  // register component
  customElements.define( 'eval-closed', EvalClosed );
